import React from "react";
import styles from "./TopHeader.module.scss";
import plus from "../../../assets/Imagess/plusvector.svg";
import Buttons from "../../Atoms/Buttons/Buttons";
import SearchInput from "../../Atoms/Inputs/SearchInput";

const TopHeader = ({
  search,
  setSearch,
  handleNewClick,
  style,
  buttonTitle,
}) => {
  return (
    <div className={styles["icon-container"]} style={{ ...style }}>
      <div>
        <SearchInput search={search} setSearch={setSearch} />
      </div>
      <div className={styles["icon-subcontainer"]}>
        <Buttons
          text={buttonTitle}
          icon={plus}
          rounded={true}
          color="rgba(13, 160, 110, 1)"
          handleOnClick={handleNewClick}
          type="submit"
        />
      </div>
    </div>
  );
};

export default TopHeader;
